import React, { memo } from 'react';

const SuitabilityProgressButtonPopupArea = props => {
  const {
    onCloseModal = () => {},
    onClickElectronicReception = () => {}, // 전자 접수
    onClickSendSuitabilitySms = () => {}, // 비대면 적합성 진단
    isMinor = false, // 미성년자 여부
    custKind = 'P',
    isForeignCurrencyInsurance = false, // 외화보험 여부
  } = props;

  const { isRestrictedUser } = $hooks.useUser();

  return (
    <>
      <p className="layer-text text-center">
        {`${isForeignCurrencyInsurance ? '외화' : '변액'}보험적합성진단 방법을`}
        <br />
        선택해주세요.
      </p>

      <div className="btn-select">
        {!isMinor && (
          <button
            type="button"
            className="btn-face"
            onClick={() => {
              onCloseModal(false);
              setTimeout(() => onClickElectronicReception(), 200);
            }}
          >
            대면적합성진단
            <span>(1일 1회)</span>
          </button>
        )}

        {/* 제한된 설계사(DM/교차) 이거나 법인 고객 비대면 진단 기능 없음 */}
        {!isRestrictedUser && custKind !== 'C' && (
          <button
            type="button"
            className="btn-omni"
            onClick={() => {
              onClickSendSuitabilitySms(true);
            }}
          >
            비대면적합성진단
            <span>(알림톡 SMS 발송)</span>
          </button>
        )}
      </div>
    </>
  );
};

export default memo(SuitabilityProgressButtonPopupArea);
